import React from 'react';
import { Card, CardContent, Box, Typography, LinearProgress, Chip } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { formatCurrency } from '../../utils/helpers';

const MRRCard = ({ data, goal }) => {
  const current = data?.current || 0;
  const change = data?.change || 0;
  const progress = Math.min((current / goal) * 100, 100);
  const isPositive = change >= 0;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '0.7rem' }}>
              Monthly Revenue
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', lineHeight: 1.2 }}>
              {formatCurrency(current)}
            </Typography>
          </Box>
          <Chip
            icon={isPositive ? <TrendingUp sx={{ fontSize: 14 }} /> : <TrendingDown sx={{ fontSize: 14 }} />}
            label={`${isPositive ? '+' : ''}${formatCurrency(change)}`}
            color={isPositive ? 'success' : 'error'}
            size="small"
            sx={{ fontWeight: 600, height: 24, fontSize: '0.75rem' }}
          />
        </Box>

        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
              Progress to {formatCurrency(goal)}
            </Typography>
            <Typography variant="caption" fontWeight={600} sx={{ fontSize: '0.75rem' }}>
              {progress.toFixed(0)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: 'grey.100',
              '& .MuiLinearProgress-bar': {
                borderRadius: 3,
                background: 'linear-gradient(90deg, #2563eb 0%, #7c3aed 100%)',
              },
            }}
          />
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          {formatCurrency(goal - current)} more to reach your goal
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MRRCard;
